export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const hideMessage = () => ({
	type: HIDE_MESSAGE
});

export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const showMessage = options => ({
	type: SHOW_MESSAGE,
	options
});
